import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	registrationId: string
	linkProfileId: string
}

export async function registrationProfileLinkApi(
	payload: RequestDataShape,
	token?: null | string,
) {
	const endpoint = "/registration/profile/link/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	return await requester.sendRequest(payload, token)
}
